import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { t } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import { useNavigate } from 'react-router-dom';
import './BackButton.css';

export type BackButtonVariant = 'editor' | 'ghost';

interface BackButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  to?: string;
  label?: React.ReactNode;
  showIcon?: boolean;
  spacing?: boolean;
  type?: 'button' | 'submit' | 'reset';
  variant?: BackButtonVariant;
}

const BackButton: React.FC<BackButtonProps> = ({
  className,
  label,
  onClick,
  showIcon = true,
  spacing = false,
  to = '/app',
  type = 'button',
  variant = 'editor',
  ...buttonProps
}) => {
  useLingui();
  const navigate = useNavigate();
  const buttonClassName = [
    'back-button',
    `back-button--${variant}`,
    spacing ? 'back-button--spaced' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onClick?.(event);
    if (!event.defaultPrevented) {
      navigate(to);
    }
  };

  return (
    <button
      {...buttonProps}
      type={type}
      className={buttonClassName}
      onClick={handleClick}
    >
      {showIcon && <ArrowBackIcon className="back-button__icon" aria-hidden="true" />}
      {label ?? t`Back to editor`}
    </button>
  );
};

export default BackButton;
